/* tslint:disable */
/* eslint-disable */
/**
 * Bikeleasing Accounts
 * Consumers of the API must follow the tolerant reader pattern. Especially the consumer    * must ignore unknown properties   * expect enumerations to be extended at any time (this includes discriminators)      These changes are considered backwards compatible.   However, we will never do a backwards-incompatible change without creating a new API version:   * removal of required properties   * removal of a supported request parameter   * adding a new required request parameter or attributes   * renaming of an attribute      All responses contain a common header `X-Request-Id` which identifies the individual HTTP request. This ID should be included in any bug reports or support requests.  There is a per-client rate limit on the API. If the rate limit is exceeded (resulting in a \"429 Too Many Requests\" response), please slow down and retry  after a short delay.  The API strives to return status codes that align with user expectations. However, in some error cases, multiple status codes may seem appropriate, and  the expected status code might not be clear. Here are two important points to consider when dealing with error status codes: 1. The API first checks the user\'s permission to access a resource. Only if the user has permission, it attempts to retrieve the resource. As a consequence, a user will     see a `403 Access Denied` status when requesting non-existent single resources since the permission check fails first. 2. There are no permissions on collections, only on the resources contained within them. Therefore, the API never returns a `403 Access Denied` status because the user     lacks permission to access a collection. Instead, the API returns a list containing all resources the user has permission to access. If the user has no permission to any     resource in the collection, an empty list with a `200 OK` status code is returned.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompleteProfileUpdateBadRequestProblemDetail } from '../dto';
// @ts-ignore
import type { CompleteProfileUpdateRequest } from '../dto';
// @ts-ignore
import type { InlineObject } from '../dto';
// @ts-ignore
import type { InlineObject1 } from '../dto';
// @ts-ignore
import type { MeCompanySettings } from '../dto';
// @ts-ignore
import type { MeCompanySettingsRequest } from '../dto';
// @ts-ignore
import type { MeEmployee } from '../dto';
// @ts-ignore
import type { MeEmployeeList } from '../dto';
/**
 * MeApi - axios parameter creator
 * @export
 */
export const MeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Completes the UpdateProfile required action for the authenticated user\'s employee profile.  This endpoint allows the user to update their profile information and removes the UpdateProfile  action from their requiredActions list. The employee must have UpdateProfile in their requiredActions,  and the employee must belong to the authenticated user.  Expected error types for bad requests: - error:account@bikeleasing:required-action-not-present - error:account@bikeleasing:incomplete-profile-data - error:account@bikeleasing:employee-not-eligible  For eligibility failures, the response includes an `eligibilityFailureReason` property. 
         * @summary Complete the UpdateProfile required action
         * @param {string} employeeId The ID of the employee to update.
         * @param {CompleteProfileUpdateRequest} completeProfileUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProfileUpdate: async (employeeId: string, completeProfileUpdateRequest: CompleteProfileUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('completeProfileUpdate', 'employeeId', employeeId)
            // verify required parameter 'completeProfileUpdateRequest' is not null or undefined
            assertParamExists('completeProfileUpdate', 'completeProfileUpdateRequest', completeProfileUpdateRequest)
            const localVarPath = `/api/v1/me/employees/{employeeId}/complete-action/update-profile`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:own-profile:write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeProfileUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a specific employee profile that belongs to the authenticated user. Returns 403 if the employee does not belong to the authenticated user.
         * @summary Get a specific employee profile
         * @param {string} employeeId The ID of the employee to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyEmployee: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getMyEmployee', 'employeeId', employeeId)
            const localVarPath = `/api/v1/me/employees/{employeeId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:own-profile:read"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all employee profiles associated with the authenticated user\'s IDP subject. Returns an empty list if the user has no associated employees.
         * @summary List all employees associated with authenticated user
         * @param {string} [companyCode] Filters employees by the company\&#39;s BLS context company code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyEmployees: async (companyCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:own-profile:read"], configuration)

            if (companyCode !== undefined) {
                localVarQueryParameter['companyCode'] = companyCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates company settings of the authenticated user\'s company.  The user must be associated with the specified company and have at least an employer level role assigned. 
         * @summary Update company settings
         * @param {string} companyId The ID of the company to update
         * @param {MeCompanySettingsRequest} meCompanySettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCompanySettings: async (companyId: string, meCompanySettingsRequest: MeCompanySettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('putCompanySettings', 'companyId', companyId)
            // verify required parameter 'meCompanySettingsRequest' is not null or undefined
            assertParamExists('putCompanySettings', 'meCompanySettingsRequest', meCompanySettingsRequest)
            const localVarPath = `/api/v1/me/company-settings/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", ["employees:own-profile:write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meCompanySettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeApi - functional programming interface
 * @export
 */
export const MeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeApiAxiosParamCreator(configuration)
    return {
        /**
         * Completes the UpdateProfile required action for the authenticated user\'s employee profile.  This endpoint allows the user to update their profile information and removes the UpdateProfile  action from their requiredActions list. The employee must have UpdateProfile in their requiredActions,  and the employee must belong to the authenticated user.  Expected error types for bad requests: - error:account@bikeleasing:required-action-not-present - error:account@bikeleasing:incomplete-profile-data - error:account@bikeleasing:employee-not-eligible  For eligibility failures, the response includes an `eligibilityFailureReason` property. 
         * @summary Complete the UpdateProfile required action
         * @param {string} employeeId The ID of the employee to update.
         * @param {CompleteProfileUpdateRequest} completeProfileUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeProfileUpdate(employeeId: string, completeProfileUpdateRequest: CompleteProfileUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeEmployee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeProfileUpdate(employeeId, completeProfileUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.completeProfileUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a specific employee profile that belongs to the authenticated user. Returns 403 if the employee does not belong to the authenticated user.
         * @summary Get a specific employee profile
         * @param {string} employeeId The ID of the employee to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyEmployee(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeEmployee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyEmployee(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.getMyEmployee']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all employee profiles associated with the authenticated user\'s IDP subject. Returns an empty list if the user has no associated employees.
         * @summary List all employees associated with authenticated user
         * @param {string} [companyCode] Filters employees by the company\&#39;s BLS context company code.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyEmployees(companyCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeEmployeeList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyEmployees(companyCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.listMyEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates company settings of the authenticated user\'s company.  The user must be associated with the specified company and have at least an employer level role assigned. 
         * @summary Update company settings
         * @param {string} companyId The ID of the company to update
         * @param {MeCompanySettingsRequest} meCompanySettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putCompanySettings(companyId: string, meCompanySettingsRequest: MeCompanySettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeCompanySettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putCompanySettings(companyId, meCompanySettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeApi.putCompanySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeApi - factory interface
 * @export
 */
export const MeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeApiFp(configuration)
    return {
        /**
         * Completes the UpdateProfile required action for the authenticated user\'s employee profile.  This endpoint allows the user to update their profile information and removes the UpdateProfile  action from their requiredActions list. The employee must have UpdateProfile in their requiredActions,  and the employee must belong to the authenticated user.  Expected error types for bad requests: - error:account@bikeleasing:required-action-not-present - error:account@bikeleasing:incomplete-profile-data - error:account@bikeleasing:employee-not-eligible  For eligibility failures, the response includes an `eligibilityFailureReason` property. 
         * @summary Complete the UpdateProfile required action
         * @param {MeApiCompleteProfileUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProfileUpdate(requestParameters: MeApiCompleteProfileUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeEmployee> {
            return localVarFp.completeProfileUpdate(requestParameters.employeeId, requestParameters.completeProfileUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a specific employee profile that belongs to the authenticated user. Returns 403 if the employee does not belong to the authenticated user.
         * @summary Get a specific employee profile
         * @param {MeApiGetMyEmployeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyEmployee(requestParameters: MeApiGetMyEmployeeRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeEmployee> {
            return localVarFp.getMyEmployee(requestParameters.employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all employee profiles associated with the authenticated user\'s IDP subject. Returns an empty list if the user has no associated employees.
         * @summary List all employees associated with authenticated user
         * @param {MeApiListMyEmployeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyEmployees(requestParameters: MeApiListMyEmployeesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<MeEmployeeList> {
            return localVarFp.listMyEmployees(requestParameters.companyCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates company settings of the authenticated user\'s company.  The user must be associated with the specified company and have at least an employer level role assigned. 
         * @summary Update company settings
         * @param {MeApiPutCompanySettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putCompanySettings(requestParameters: MeApiPutCompanySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeCompanySettings> {
            return localVarFp.putCompanySettings(requestParameters.companyId, requestParameters.meCompanySettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for completeProfileUpdate operation in MeApi.
 * @export
 * @interface MeApiCompleteProfileUpdateRequest
 */
export interface MeApiCompleteProfileUpdateRequest {
    /**
     * The ID of the employee to update.
     * @type {string}
     * @memberof MeApiCompleteProfileUpdate
     */
    readonly employeeId: string

    /**
     * 
     * @type {CompleteProfileUpdateRequest}
     * @memberof MeApiCompleteProfileUpdate
     */
    readonly completeProfileUpdateRequest: CompleteProfileUpdateRequest
}

/**
 * Request parameters for getMyEmployee operation in MeApi.
 * @export
 * @interface MeApiGetMyEmployeeRequest
 */
export interface MeApiGetMyEmployeeRequest {
    /**
     * The ID of the employee to retrieve.
     * @type {string}
     * @memberof MeApiGetMyEmployee
     */
    readonly employeeId: string
}

/**
 * Request parameters for listMyEmployees operation in MeApi.
 * @export
 * @interface MeApiListMyEmployeesRequest
 */
export interface MeApiListMyEmployeesRequest {
    /**
     * Filters employees by the company\&#39;s BLS context company code.
     * @type {string}
     * @memberof MeApiListMyEmployees
     */
    readonly companyCode?: string
}

/**
 * Request parameters for putCompanySettings operation in MeApi.
 * @export
 * @interface MeApiPutCompanySettingsRequest
 */
export interface MeApiPutCompanySettingsRequest {
    /**
     * The ID of the company to update
     * @type {string}
     * @memberof MeApiPutCompanySettings
     */
    readonly companyId: string

    /**
     * 
     * @type {MeCompanySettingsRequest}
     * @memberof MeApiPutCompanySettings
     */
    readonly meCompanySettingsRequest: MeCompanySettingsRequest
}

/**
 * MeApi - object-oriented interface
 * @export
 * @class MeApi
 * @extends {BaseAPI}
 */
export class MeApi extends BaseAPI {
    /**
     * Completes the UpdateProfile required action for the authenticated user\'s employee profile.  This endpoint allows the user to update their profile information and removes the UpdateProfile  action from their requiredActions list. The employee must have UpdateProfile in their requiredActions,  and the employee must belong to the authenticated user.  Expected error types for bad requests: - error:account@bikeleasing:required-action-not-present - error:account@bikeleasing:incomplete-profile-data - error:account@bikeleasing:employee-not-eligible  For eligibility failures, the response includes an `eligibilityFailureReason` property. 
     * @summary Complete the UpdateProfile required action
     * @param {MeApiCompleteProfileUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public completeProfileUpdate(requestParameters: MeApiCompleteProfileUpdateRequest, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).completeProfileUpdate(requestParameters.employeeId, requestParameters.completeProfileUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a specific employee profile that belongs to the authenticated user. Returns 403 if the employee does not belong to the authenticated user.
     * @summary Get a specific employee profile
     * @param {MeApiGetMyEmployeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public getMyEmployee(requestParameters: MeApiGetMyEmployeeRequest, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).getMyEmployee(requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all employee profiles associated with the authenticated user\'s IDP subject. Returns an empty list if the user has no associated employees.
     * @summary List all employees associated with authenticated user
     * @param {MeApiListMyEmployeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public listMyEmployees(requestParameters: MeApiListMyEmployeesRequest = {}, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).listMyEmployees(requestParameters.companyCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates company settings of the authenticated user\'s company.  The user must be associated with the specified company and have at least an employer level role assigned. 
     * @summary Update company settings
     * @param {MeApiPutCompanySettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeApi
     */
    public putCompanySettings(requestParameters: MeApiPutCompanySettingsRequest, options?: RawAxiosRequestConfig) {
        return MeApiFp(this.configuration).putCompanySettings(requestParameters.companyId, requestParameters.meCompanySettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

